
{
  "fr": {
    "configuratorLayerEditorModalTextToolbar": {
      "action": {
        "bold": "Gras",
        "italic": "Italique",
        "underlined": "Souligné"
      },
      "text": {
        "placeholder": "Saisissez votre texte"
      },
      "typoSelect": {
        "placeholder": "Sélectionnez une police d'écriture"
      }
    }
  }
}
